import { array } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { EMAIL_ATTACHMENTS_MAX_TOTAL_BYTES } from "../../../../domain/constants";

type TSizedAttachment = {
    file_size_bytes: number | null;
};

export type TAttachmentSizeSummary = {
    knownBytes: number;
    unknownSizeCount: number;
    isOverBudget: boolean;
};

// file_size_bytes is still null on ~5% of legal_files and new ones are created daily, so
// this total is a floor rather than the truth — sendLegalEmail weighs the built message
// against the real SES limit and is the gate that actually holds.
export const getAttachmentSizeSummary = (attachments: Array<TSizedAttachment>): TAttachmentSizeSummary => {
    const knownBytes = pipe(
        attachments,
        array.reduce(0, (total, attachment) => total + (attachment.file_size_bytes ?? 0)),
    );

    return {
        knownBytes,
        unknownSizeCount: attachments.filter(({ file_size_bytes }) => file_size_bytes === null).length,
        isOverBudget: knownBytes > EMAIL_ATTACHMENTS_MAX_TOTAL_BYTES,
    };
};

export const formatAttachmentSize = (bytes: number): string => {
    const megabytes = bytes / (1024 * 1024);
    return megabytes >= 10 || megabytes === Math.round(megabytes)
        ? `${Math.round(megabytes)}MB`
        : `${megabytes.toFixed(1)}MB`;
};
